import { createContext, useContext } from 'react';

import type { useRadioGroupState } from './useRadioGroupState';

export type RadioGroupState = ReturnType<typeof useRadioGroupState>;
export const RadioGroupContext = createContext<RadioGroupState | null>(null);
export const useRadioGroupContext = () => {
  return useContext(RadioGroupContext);
};
